import { FontWeights, mergeStyleSets, useTheme } from "@fluentui/react";

export const useStyles = () => {
  const theme = useTheme();

  return mergeStyleSets({
    scrollable: {
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto',
      flexGrow: 1,
    },
    groupHeader: {
      minHeight: '32px',
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '12px',
      fontWeight: FontWeights.semibold,
      fontSize: '14px',
      color: theme.palette.neutralTertiary,
      backgroundColor: theme.palette.neutralLighter,
    },
    noItemMessage: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      color: theme.palette.neutralTertiaryAlt,
    },
  })
}
